import { find, isNil, map, pipe, propEq, propOr, reject } from 'ramda';
import LocaleKeys from '../../locales/keys';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../customer/ewallet/ewallet.constants';
import { MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import cloneDeep from 'lodash/cloneDeep';
import { retrieveCustomerAddresses, setAddressData } from '../../reducers/actions/customer.addresses.actions';
import { MaskCreditCardNumberSelector } from '../../reducers/selectors/customer.actions.template.selectors';
import { PostalCodeSelector } from '../../reducers/selectors/customer.addresses.selectors';
import { CurrentCustomerIdSelector } from '../../reducers/selectors/customer.selectors';
import { PaymentInstrumentTypeValueOptions, SelectedPaymentTypeRequiresAddress, SubscriberExternalGiftCardTypeOptionsWithRegexes } from '../../reducers/selectors/modify.payment.method.popup.selectors';
import { EditAddressPopupStateRegionProvinceValueOptions, MakePaymentAddressSelector, MakePaymentAddressesSelector } from '../customer/makePayment/make.payment.selectors';
import { setMakePaymentInstrumentBillingAddress, setMakePaymentAddressStateValue, setMakePaymentInstrument } from '../../reducers/actions/make.payment.actions';
import { NewPaymentMethodWithTypeNamesAndMetadataViewModelSelector, PaymentIsCreatingOrEditingDataSelector } from '../../reducers/selectors/customer.ewallet.selectors';
import { BLANK_PAYMENT_INSTRUMENT, NO_FORM_ERRORS } from '../customer/makePayment/make.payment.constants';
import { addressStateRegionProvinceValueOptionsForCountry } from '../../reducers/helpers/customer.selectors.helpers';
import { buildPaymentInstrumentRequest } from './payment.billing.address.form.helper';
import { parseAdditionalProperties, PaymentInstrumentConfigurationAdditionalProperties, paymentInstrumentConfigurationAdditionalPropertyDescriptors } from '../../reducers/helpers/payment.instrument.additional.property.parser';
import { stateRequiredHelper } from './../customer/addresses/address.helper';
function PaymentBillingAddressFormController($ngRedux, uiNotificationService) {
  var _this = this;
  this.$onInit = function () {
    _this.$ngRedux = $ngRedux;
    _this.uiNotificationService = uiNotificationService;
    _this.editPaymentInstrument = cloneDeep(BLANK_PAYMENT_INSTRUMENT);
    _this.formErrors = NO_FORM_ERRORS;
    _this.LocaleKeys = LocaleKeys;
    _this.PaymentTypes = SUPPORTED_PAYMENT_INSTRUMENT_TYPES;
    _this.resetStateFlag = true;
    _this.loadingIndicator = false;
    _this.formNameMap = new Map([[SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD, 'creditCardController.creditCardForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD, 'giftCardController.giftCardForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD, 'externalGiftCardController.externalGiftCardForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL, '$ctrl.externalBillForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK, 'eCheckController.echeckForm']]);
    _this.CHANGE_CARD_TYPE = 'cardType';
    var mapStateToTarget = function mapStateToTarget(store) {
      return {
        addressCountriesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressCountry, store),
        addressCountriesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressCountry, store),
        addressCountriesOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.AddressCountry, store),
        addressStatesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
        addressStatesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
        addressRequirements: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressRequirements, store),
        addressRequirementsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressRequirements, store),
        addressStatesOptions: EditAddressPopupStateRegionProvinceValueOptions(store),
        currentCustomerId: CurrentCustomerIdSelector(store),
        creditCardTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.CreditCardType, store),
        externalBillTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.ExternalBillType, store),
        externalBillTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalBillType, store),
        externalGiftCardTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalGiftCardType, store),
        externalGiftCardTypes: SubscriberExternalGiftCardTypeOptionsWithRegexes(store),
        isCreatingOrEditingData: PaymentIsCreatingOrEditingDataSelector(store),
        makePaymentAddress: MakePaymentAddressSelector(store),
        makePaymentAddresses: MakePaymentAddressesSelector(store),
        maskCreditCardNumber: MaskCreditCardNumberSelector(store),
        newPaymentMethodWithMetadata: NewPaymentMethodWithTypeNamesAndMetadataViewModelSelector(store),
        paymentInstrumentConfiguration: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.PaymentInstrumentConfiguration, store),
        paymentInstrumentConfigurationLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PaymentInstrumentConfiguration, store),
        paymentInstrumentTypes: PaymentInstrumentTypeValueOptions(store),
        paymentInstrumentTypeLoaded: MetadataSelectors.codes.PaymentInstrumentTypeLoadedSelector(store),
        paymentTypeRequiresAddress: SelectedPaymentTypeRequiresAddress(store),
        postalCode: PostalCodeSelector(store)
      };
    };
    var controllerActions = {
      fetchCodeType: MetadataActions.codes.fetchCodeTypes,
      retrieveCustomerAddresses: retrieveCustomerAddresses,
      setAddressData: setAddressData,
      setMakePaymentAddressStateValue: setMakePaymentAddressStateValue,
      setMakePaymentInstrumentBillingAddress: setMakePaymentInstrumentBillingAddress,
      setMakePaymentInstrument: setMakePaymentInstrument
    };
    _this.disconnectRedux = _this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    if (!_this.state.addressCountriesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressCountry);
    }
    if (!_this.state.addressStatesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressStateProvinceRegion);
    }
    if (!_this.state.creditCardTypes.length) {
      _this.actions.fetchCodeType(MetadataConstants.codes.CreditCardType);
    }
    if (!_this.state.paymentInstrumentTypeLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.PaymentInstrumentType);
    }
    if (!_this.state.addressRequirementsLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressRequirements);
    }
    if (!_this.state.externalBillTypesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.ExternalBillType);
    }
    if (!_this.state.externalGiftCardTypesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.ExternalGiftCardType);
    }
    if (!_this.state.paymentInstrumentConfigurationLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.PaymentInstrumentConfiguration);
    }
    _this.retrieveCustomerAddresses();
    _this.setUpDialogKeys();
    _this.filteredPaymentInstruments = _this.getPaymentTypes();
    _this.setPaymentInstrumentType();
    _this.onAddressFormChanged = _this.onAddressFormChanged.bind(_this);
  };
  this.setPaymentInstrumentType = function () {
    if (isNil(_this.editPaymentInstrument) || isNil(_this.editPaymentInstrument.Type) || !_this.isEditingPaymentInstrument) {
      _this.handlePaymentTypeChange(_this.filteredPaymentInstruments[0]);
    }
  };
  this.filterPaymentTypes = function (instrumentTypes) {
    var typesToFilter = map(function (type) {
      return type.toString();
    }, instrumentTypes);
    return _this.state.paymentInstrumentTypes.filter(function (type) {
      return typesToFilter.includes(type.paymentInstrumentType.Value);
    });
  };
  this.getPaymentTypes = function () {
    if (_this.paymentInstrumentTypes) {
      return _this.filterPaymentTypes(_this.paymentInstrumentTypes);
    } else {
      return _this.state.paymentInstrumentTypes;
    }
  };
  this.setUpDialogKeys = function () {
    _this.dialogTextKeys = {
      edit: {
        title: _this.LocaleKeys.MAKE_PAYMENT.EDIT_PAYMENT_TITLE,
        callToAction: _this.LocaleKeys.MAKE_PAYMENT.EDIT_PAYMENT_BUTTON
      },
      new: {
        title: _this.LocaleKeys.MAKE_PAYMENT.ADD_NEW_PAYMENT_METHOD,
        callToAction: _this.LocaleKeys.MAKE_PAYMENT.ADD_METHOD
      }
    };
  };
  this.retrieveCustomerAddresses = function () {
    _this.actions.retrieveCustomerAddresses(_this.state.currentCustomerId, true);
  };
  var generateRequestObject = function generateRequestObject() {
    if (_this.paymentInstrumentForm && _this.paymentInstrumentForm.$valid) {
      _this.formErrors = NO_FORM_ERRORS;
      createRequestObject();
    }
  };
  var createRequestObject = function createRequestObject() {
    if (_this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD) {
      _this.requestObject = {
        Pin: _this.editPaymentInstrument.GiftCard.pin,
        CustomerId: _this.state.currentCustomerId
      };
    } else {
      var requestData = {
        paymentTypeRequiresAddress: _this.state.paymentTypeRequiresAddress,
        editPaymentInstrument: _this.editPaymentInstrument,
        makePaymentAddress: _this.state.makePaymentAddress,
        creditCardTypes: _this.state.creditCardTypes,
        externalBillTypes: _this.state.externalBillTypes,
        externalGiftCardTypes: _this.state.externalGiftCardTypes,
        paymentInstrumentTypes: _this.state.paymentInstrumentTypes,
        currentCustomerId: _this.state.currentCustomerId
      };
      Object.assign(_this.requestObject, buildPaymentInstrumentRequest(!_this.isEditingPaymentInstrument, requestData));
    }
  };
  this.resetForm = function () {
    _this.editPaymentInstrument = cloneDeep(BLANK_PAYMENT_INSTRUMENT);
    if (_this.paymentInstrumentForm) {
      _this.paymentInstrumentForm.$setPristine();
      _this.paymentInstrumentForm.$setUntouched();
    }
    _this.addressFormModel = {};
    _this.formErrors = NO_FORM_ERRORS;
  };
  this.shouldShowNewEditLoading = function () {
    return _this.state.isCreatingOrEditingData || _this.loadingIndicator;
  };
  var transformAdditionalProperties = function transformAdditionalProperties(additionalProperty) {
    var baseObject = new PaymentInstrumentConfigurationAdditionalProperties();
    return parseAdditionalProperties(baseObject, additionalProperty.AdditionalProperties, paymentInstrumentConfigurationAdditionalPropertyDescriptors);
  };
  this.shouldRequirePhoneNumber = function (instrumentType) {
    return pipe(reject(propEq(true, 'Global')), map(transformAdditionalProperties), find(propEq(instrumentType, 'paymentInstrumentTypeCode')), propOr(false, 'requirePhoneNumber'))(_this.state.paymentInstrumentConfiguration);
  };
  this.handleChangeDropDownAddress = function () {
    _this.loadingIndicator = true;
    if (!addressStateRegionProvinceValueOptionsForCountry(_this.state.makePaymentAddress.Country, _this.state.addressCountriesAll, _this.state.addressStatesAll)) {
      _this.resetStateFlag = false;
    }
    _this.actions.setMakePaymentInstrumentBillingAddress(cloneDeep(_this.state.makePaymentAddress));
    _this.editPaymentInstrument.BillingAddress = cloneDeep(_this.state.makePaymentAddress);
    _this.actions.setMakePaymentInstrument(_this.editPaymentInstrument);
    _this.updateStateField();
    _this.loadingIndicator = false;
  };
  this.handlePaymentTypeChange = function (selectedPaymentTypeOption) {
    _this.resetForm();
    if (selectedPaymentTypeOption && selectedPaymentTypeOption.paymentInstrumentType) {
      _this.editPaymentInstrument.Type = selectedPaymentTypeOption.paymentInstrumentType.Value;
    }
    _this.updatePaymentInstrumentEditCopy();
  };
  this.updateStateField = function () {
    _this.actions.setAddressData(_this.editPaymentInstrument.BillingAddress);
    _this.stateRequired = stateRequiredHelper(_this.state.addressRequirements, _this.state.addressStatesOptions);
    // if Country has states, reset State if it's not one of them
    if (_this.state.addressStatesOptions && !_this.state.addressStatesOptions.find(function (stateOption) {
      return stateOption.value === _this.editPaymentInstrument.BillingAddress.State;
    })) {
      _this.editPaymentInstrument.BillingAddress.State = null;
      _this.actions.setMakePaymentAddressStateValue(null);
      _this.addressFormModel.stateRegionProvince = _this.editPaymentInstrument.BillingAddress.State;
    }
    _this.updateAddressFormModel();
  };
  this.handleChangeFormCountry = function () {
    _this.updateStateField();
  };
  this.updatePaymentInstrumentEditCopy = function (changes) {
    if (isNil(changes) || changes === _this.CHANGE_CARD_TYPE) {
      _this.actions.setMakePaymentInstrument(cloneDeep(_this.editPaymentInstrument));
    }
    generateRequestObject();
    _this.editPaymentInstrument = _this.state.newPaymentMethodWithMetadata;
    _this.updateAddressFormModel();
  };
  this.updatePaymentInstrumentOnBlur = function () {
    _this.updatePaymentInstrumentEditCopy();
  };
  this.onAddressFormChanged = function (addressFormModel) {
    /*
        Check if the addressForm country field changed if
        then trigger handleChangeForm route
    */
    if (Object.values(addressFormModel).filter(function (value) {
      return value;
    }).length > 0) {
      _this.editPaymentInstrument.BillingAddress.LineOne = addressFormModel.addressLine1;
      _this.editPaymentInstrument.BillingAddress.LineTwo = addressFormModel.addressLine2;
      _this.editPaymentInstrument.BillingAddress.City = addressFormModel.city;
      _this.editPaymentInstrument.BillingAddress.State = addressFormModel.stateRegionProvince;
      _this.editPaymentInstrument.BillingAddress.PostalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
      _this.editPaymentInstrument.BillingAddress.ShipToName = addressFormModel.shipToName;
      _this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
      _this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
      _this.addressFormModel.city = addressFormModel.city;
      _this.addressFormModel.country = addressFormModel.country;
      _this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
      _this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
      if (addressFormModel.country !== _this.editPaymentInstrument.BillingAddress.Country) {
        _this.editPaymentInstrument.BillingAddress.Country = addressFormModel.country;
        _this.handleChangeFormCountry();
      }
    }
  };
  this.updateAddressFormModel = function () {
    if (!_this.editPaymentInstrument || !_this.editPaymentInstrument.BillingAddress) {
      return;
    }
    _this.addressFormModel.shipToName = _this.editPaymentInstrument.BillingAddress.ShipToName;
    _this.addressFormModel.country = _this.editPaymentInstrument.BillingAddress.Country;
    _this.addressFormModel.addressLine1 = _this.editPaymentInstrument.BillingAddress.LineOne;
    _this.addressFormModel.addressLine2 = _this.editPaymentInstrument.BillingAddress.LineTwo;
    _this.addressFormModel.city = _this.editPaymentInstrument.BillingAddress.City;
    _this.addressFormModel.stateRegionProvince = _this.editPaymentInstrument.BillingAddress.State;
    _this.addressFormModel.postalCode = _this.editPaymentInstrument.BillingAddress.PostalCode;
  };
  this.$onDestroy = function () {
    _this.disconnectRedux();
  };
}
export default {
  template: require('./payment.billing.address.form.html'),
  controller: PaymentBillingAddressFormController,
  controllerAs: 'paymentBillingAddressForm',
  bindings: {
    isEditingPaymentInstrument: '<',
    paymentInstrument: '<',
    paymentInstrumentTypes: '<',
    requestObject: '<'
  }
};